import React from "react";
import PropTypes from "prop-types";
import { MostUsedFoodItems } from "./MostUsedFoodItems";
import { EmptyFood } from "../empty-states/EmptyFood";
import { capitalizeFirstLetter } from "../../../../../utils/string-helpers";
import SvgIcon from "../../../../../parts/SvgIcon";

export const RecentFoods = ({
  mostUsedToUse,
  location,
  setFoodActionState,
  onItemSelect,
}) => {
  /**
   * Function to get the title text
   * @returns
   */
  const getTitle = () => {
    if (location === "all") return "Most Used Foods";
    return `Recent ${capitalizeFirstLetter(location)}`;
  };

  const icon =
    location === "meals"
      ? "/img/new-icons/meal.svg"
      : "/img/new-icons/food.svg";

  return (
    <div className="display-food">
      {mostUsedToUse.length > 0 ? (
        <>
          <div className="title">
            <span className="font-bold">{getTitle()}</span>
            {(location === "foods" || location === "meals") && (
              <div className="identifier">
                <SvgIcon src={icon} noFilterOnLight={false} />
                <span className="opacity-70">
                  {capitalizeFirstLetter(location.slice(0, -1))}
                </span>
              </div>
            )}
          </div>
          <MostUsedFoodItems
            data={mostUsedToUse}
            setFoodActionState={setFoodActionState}
            location={location}
            onItemSelect={onItemSelect}
          />
        </>
      ) : (
        <EmptyFood label={location} variant="recent" />
      )}
    </div>
  );
};

RecentFoods.propTypes = {
  mostUsedToUse: PropTypes.array,
  location: PropTypes.string,
  onItemSelect: PropTypes.func,
  setFoodActionState: PropTypes.func,
};
